var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonsterIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 106,
    viewBox: "0 0 86 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12387_385808)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 106,
    fill: "#1F81B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.80209 57.7847C-4.80209 57.7847 -15.7368 71.8115 -18.2229 94.3381C-18.2229 94.3381 -20.4596 118.043 -8.59631 123.934C-8.59631 123.934 1.06785 128.627 5.09102 118.18C5.09102 118.18 -7.17817 78.7455 -0.521704 54.0675C-0.521704 54.0675 -0.56885 52.8984 -1.23096 53.0246C-1.81803 53.1182 -2.8924 54.1772 -4.80209 57.7847Z",
    fill: "url(#paint0_linear_12387_385808)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M-4.43719 57.1051C-4.43719 57.1051 -2.40848 102.915 2.31385 119.497C2.31385 119.497 0.16551 119.564 0.314135 121.475C0.314135 121.475 -5.15934 93.28 -6.5717 60.3546L-4.43719 57.1051Z",
    fill: "#181D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5823 39.3376C82.5823 39.3376 97.686 48.7289 107.793 69.0135C107.793 69.0135 118.074 90.4901 108.972 100.113C108.972 100.113 101.521 107.854 94.14 99.4364C94.14 99.4364 92.0462 58.1906 77.282 37.326C77.282 37.326 76.9228 36.2123 77.5878 36.1023C78.1711 35.9876 79.5449 36.6107 82.5823 39.3376Z",
    fill: "url(#paint1_linear_12387_385808)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M82.0051 38.8249C82.0051 38.8249 95.9105 82.5205 97.2007 99.7131C97.2007 99.7131 99.2405 99.0354 99.7605 100.88C99.7605 100.88 95.1672 72.5281 85.1299 41.1381L82.0051 38.8249Z",
    fill: "#181D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5117 80.7944C44.9417 86.2975 45.486 108.656 45.5614 117.306C45.5984 119.096 47.1614 120.44 48.8812 120.134L60.1829 118.122C63.7318 117.49 62.9529 112.008 59.3641 112.415C58.8677 112.474 58.3986 112.529 57.9345 112.611C55.5545 113.006 53.8211 110.388 55.0199 108.263C62.2051 95.6253 65.1642 79.9738 65.9845 74.931C66.2208 73.4112 65.2584 71.96 63.7885 71.6132C61.6184 71.1303 58.2948 71.2874 54.8552 71.8997C47.2388 73.2556 39.0642 76.855 41.5117 80.7944Z",
    fill: "url(#paint2_linear_12387_385808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8209 -0.629574C57.359 2.73093 51.3232 14.1751 54.6482 17.736C57.9502 21.3009 69.3609 15.651 72.8228 12.2905C76.2576 8.91055 76.3692 3.30513 73.04 -0.279234C70.9401 -2.52817 67.9972 -3.4128 65.2515 -2.92401C63.627 -2.63481 62.0863 -1.87483 60.8209 -0.629574Z",
    fill: "url(#paint3_linear_12387_385808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8213 6.26901C73.0906 2.1645 70.6641 0.0695882 65.8366 0.928653C61.0092 1.78772 60.2587 8.13533 60.7155 10.7016C61.2866 13.9094 62.8029 15.3832 67.0898 14.62C71.3767 13.8569 74.552 10.3735 73.8213 6.26901Z",
    fill: "url(#paint4_linear_12387_385808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.1171 14.5249C-11.9818 19.0339 -9.96552 24.2605 -5.57528 26.2474C-1.16634 28.2068 11.4931 29.5716 13.362 25.0861C15.2537 20.5966 5.63934 11.9385 1.23041 9.97915C-0.387051 9.24712 -2.09536 9.06554 -3.71986 9.35474C-6.46549 9.84353 -8.92232 11.6894 -10.1171 14.5249Z",
    fill: "url(#paint5_linear_12387_385808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.58749 20.9396C-9.31819 16.8351 -7.76373 14.0315 -2.93637 13.1718C1.891 12.312 4.78601 18.0106 5.24286 20.5769C5.81393 23.7847 4.89941 25.6913 0.612504 26.4544C-3.6744 27.2176 -7.85679 25.0441 -8.58749 20.9396Z",
    fill: "url(#paint6_linear_12387_385808)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6808 -6.67307C33.4006 -2.62969 32.6826 0.879819 31.0771 1.16563C29.4716 1.45145 27.5866 -1.59466 26.8668 -5.63804C26.1469 -9.68142 26.8649 -13.1909 28.4704 -13.4767C30.0759 -13.7626 31.9609 -10.7164 32.6808 -6.67307Z",
    fill: "url(#paint7_linear_12387_385808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4409 -5.19834C30.7288 -1.5131 30.5385 2.0738 32.0109 2.80652C33.4833 3.53924 36.0676 1.1504 37.7875 -2.54639C39.4996 -6.23163 39.6899 -9.81853 38.2175 -10.5513C37.9582 -10.6777 37.6555 -10.7151 37.3303 -10.6573C35.8479 -10.3933 33.8547 -8.23154 32.4409 -5.19834Z",
    fill: "url(#paint8_linear_12387_385808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3325 -7.3667C19.2036 -6.17094 20.6199 -2.87031 23.4985 -0.00254129C26.3883 2.87336 29.638 4.22349 30.767 3.02773C31.896 1.83196 30.4796 -1.46867 27.6011 -4.33643C25.2276 -6.69521 22.611 -8.03623 21.1286 -7.77234C20.8034 -7.71445 20.5323 -7.57482 20.3325 -7.3667Z",
    fill: "url(#paint9_linear_12387_385808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.61982 24.2127C-2.61982 24.2127 -8.68815 55.937 0.973637 112.44C0.973637 112.44 4.37539 159.435 57.4812 149.879C57.4812 149.879 97.2927 145.958 98.9461 110.627C98.9461 110.627 96.8585 78.8229 82.9319 40.7501C82.9319 40.7501 72.0475 14.1889 67.0062 6.50606C67.0062 6.50606 56.1468 -7.08698 30.2316 -3.18849C30.2316 -3.18849 29.9253 -3.2361 29.4441 -3.15044C25.0171 -2.36234 2.19247 2.72246 -2.61982 24.2127Z",
    fill: "url(#paint10_linear_12387_385808)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.316,
    cy: 33.2345,
    rx: 35.8003,
    ry: 34.6115,
    transform: "rotate(-10.0942 36.316 33.2345)",
    fill: "url(#paint11_linear_12387_385808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3317 69.6084C75.8186 77.9606 63.4599 87.1474 46.7245 90.1267C29.9917 93.1056 14.8583 86.7209 13.7324 80.3965C12.2437 72.034 26.933 75.9241 43.6658 72.9453C60.4012 69.966 72.843 61.2459 74.3317 69.6084Z",
    fill: "#FFF8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5833 71.4144C26.8545 74.3925 12.1567 70.5049 13.6436 78.857C15.1305 87.2091 29.9142 91.5799 46.6431 88.6018C63.3719 85.6237 75.739 76.4194 74.2521 68.0673C73.6582 64.731 71.3127 64.1279 67.6672 64.7768C62.1655 65.7563 53.6475 69.6227 43.5833 71.4144Z",
    fill: "url(#paint12_linear_12387_385808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2366 89.3706C36.6478 89.7301 41.5467 89.4999 46.6474 88.5919C51.6573 87.7 56.2779 86.2569 60.2491 84.4372C57.3525 82.8879 52.9395 80.9987 50.9835 82.5132C47.9626 84.8805 44.6375 85.1301 42.0113 84.2816C41.3034 84.0439 40.4197 83.9872 39.4318 84.1631C37.2646 84.5489 34.6028 86.0713 32.2366 89.3706Z",
    fill: "url(#paint13_radial_12387_385808)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M52.5572 95.6971C51.1652 96.1252 49.6742 96.4933 48.0986 96.7737C46.7189 97.0194 45.3751 97.1797 44.0826 97.269C31.9398 97.8978 25.3971 93.2522 27.5911 93.4852C29.3467 93.3753 35.1161 94.8416 42.0368 94.4411C43.8332 94.345 45.6996 94.139 47.5689 93.7984C49.5924 93.4474 51.5613 92.9482 53.4017 92.3587C59.8283 90.3396 64.559 87.0988 66.2113 86.6099C68.154 85.6615 63.7953 92.0334 52.5572 95.6971Z",
    fill: "#181D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7408 73.9722C16.7492 74.2505 16.7815 74.5245 16.8334 74.8161C17.3292 77.6015 19.4431 79.5478 21.5595 79.171C23.6719 78.7949 24.9882 76.238 24.4924 73.4527C24.4631 73.2883 24.4259 73.1254 24.3807 72.964C22.2153 73.0655 20.2961 73.2079 18.6948 73.493C17.976 73.621 17.3237 73.7752 16.7408 73.9722Z",
    fill: "url(#paint14_linear_12387_385808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1841 78.1984C19.7692 78.6901 20.438 78.8424 20.681 78.5373C20.9222 78.2324 20.6472 77.5855 20.0631 77.0947C19.4798 76.6028 18.809 76.4488 18.5678 76.7538C18.324 77.0599 18.6008 77.7066 19.1841 78.1984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1486 73.1594C26.6449 75.9441 28.7582 77.8905 30.8727 77.5153C32.8096 77.1694 34.0648 75.0201 33.9002 72.5306C31.113 72.7085 28.4939 72.7877 26.114 72.8845C26.1145 72.9734 26.1299 73.0684 26.1486 73.1594Z",
    fill: "url(#paint15_linear_12387_385808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5017 76.5397C29.086 77.0324 29.7556 77.1838 29.9986 76.8787C30.2398 76.5737 29.9648 75.9269 29.3807 75.436C28.7957 74.9443 28.1266 74.7901 27.8846 75.0961C27.6417 75.4012 27.9184 76.0479 28.5017 76.5397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1923 75.8553C41.9593 75.5407 43.1716 73.7032 43.2261 71.4767C40.6431 71.922 38.1155 72.1999 35.6899 72.3983C36.4319 74.6871 38.3099 76.1904 40.1923 75.8553Z",
    fill: "url(#paint16_linear_12387_385808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8179 74.8809C38.4014 75.3724 39.0721 75.5242 39.3131 75.2191C39.5551 74.9149 39.2806 74.2672 38.6962 73.7766C38.1117 73.2843 37.4408 73.1307 37.2008 73.4366C36.958 73.7419 37.2333 74.3886 37.8179 74.8809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.144 71.1101C45.9584 73.1929 47.7399 74.5119 49.5134 74.1962C51.4199 73.8568 52.6827 71.7376 52.539 69.2743C50.2057 69.9539 47.728 70.5931 45.144 71.1101Z",
    fill: "url(#paint17_linear_12387_385808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1346 73.2225C47.7174 73.715 48.3881 73.8668 48.6291 73.5617C48.8719 73.2565 48.5966 72.6098 48.0122 72.1193C47.4276 71.6269 46.7575 71.4723 46.5157 71.7784C46.2729 72.0837 46.5483 72.7304 47.1346 73.2225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2298 68.7672C54.8975 71.2315 56.8605 72.8896 58.8321 72.5373C60.9463 72.1601 62.2593 69.6044 61.7625 66.8209C61.7358 66.6706 61.7029 66.5258 61.6637 66.3866C59.4165 67.0969 56.9257 67.9449 54.2298 68.7672Z",
    fill: "url(#paint18_linear_12387_385808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4507 71.5641C57.0358 72.0558 57.7046 72.2082 57.9476 71.9031C58.1888 71.5981 57.9138 70.9513 57.3297 70.4604C56.7447 69.9687 56.0764 69.8136 55.8336 70.1205C55.5924 70.4254 55.8674 71.0723 56.4507 71.5641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3323 65.8692C63.3503 66.0864 63.3724 66.3029 63.4119 66.5247C63.9077 69.3099 66.0255 71.2555 68.1379 70.8794C70.2542 70.5027 71.5745 67.9451 71.0786 65.1598C71.0457 64.975 71.0095 64.7949 70.9621 64.6211C70.0302 64.4776 68.9149 64.5533 67.6451 64.7793C66.3634 65.0075 64.9198 65.3916 63.3323 65.8692Z",
    fill: "url(#paint19_linear_12387_385808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7684 69.9052C66.3526 70.3979 67.0223 70.5492 67.2652 70.2441C67.5064 69.9392 67.2315 69.2923 66.6474 68.8015C66.0641 68.3096 65.3933 68.1556 65.1513 68.4615C64.9083 68.7666 65.1851 69.4133 65.7684 69.9052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M36.0808 37.6141C37.7972 47.2557 31.5919 56.4234 22.2213 58.0916C12.852 59.7596 3.86286 53.2968 2.14643 43.6552C0.430453 34.0162 6.637 24.8483 16.0063 23.1803C25.3769 21.5122 34.3648 27.9751 36.0808 37.6141Z",
    fill: "#181D1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9796 37.8113C36.5847 46.8277 30.7813 55.4016 22.0173 56.9618C13.2532 58.522 4.84739 52.4776 3.24227 43.4613C1.63715 34.4449 7.44058 25.8709 16.2046 24.3107C24.9686 22.7505 33.3745 28.7949 34.9796 37.8113Z",
    fill: "url(#paint20_radial_12387_385808)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6497 39.114C28.5132 43.9644 25.3912 48.5768 20.6766 49.4161C15.9619 50.2554 11.4399 47.0038 10.5765 42.1535C9.71299 37.3031 12.835 32.6907 17.5496 31.8514C22.2643 31.0121 26.7862 34.2637 27.6497 39.114Z",
    fill: "url(#paint21_radial_12387_385808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1064 39.9234C23.5105 42.1935 22.0514 44.3493 19.8448 44.7421C17.6394 45.1347 15.5247 43.6152 15.1205 41.345C14.7166 39.0762 16.1768 36.9189 18.3822 36.5263C20.5888 36.1335 22.7025 37.6545 23.1064 39.9234Z",
    fill: "#2D2A49"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.3403,
    cy: 36.2958,
    rx: 4.82753,
    ry: 3.81623,
    transform: "rotate(-10.0942 18.3403 36.2958)",
    fill: "url(#paint22_linear_12387_385808)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M72.3108 31.1642C74.0272 40.8058 67.822 49.9735 58.4514 51.6416C49.0821 53.3096 40.093 46.8469 38.3766 37.2053C36.6606 27.5662 42.8671 18.3983 52.2364 16.7304C61.6069 15.0622 70.5948 21.5251 72.3108 31.1642Z",
    fill: "#181D1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.2117 31.3611C72.8168 40.3774 67.0134 48.9514 58.2493 50.5116C49.4853 52.0719 41.0794 46.0275 39.4743 37.0111C37.8691 27.9947 43.6726 19.4208 52.4366 17.8605C61.2007 16.3003 69.6066 22.3447 71.2117 31.3611Z",
    fill: "url(#paint23_radial_12387_385808)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8817 32.6646C64.7451 37.5149 61.6232 42.1274 56.9085 42.9667C52.1939 43.806 47.6719 40.5544 46.8084 35.704C45.945 30.8536 49.0669 26.2412 53.7816 25.4019C58.4962 24.5626 63.0182 27.8142 63.8817 32.6646Z",
    fill: "url(#paint24_radial_12387_385808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3364 33.4727C59.7406 35.7428 58.2814 37.8986 56.0748 38.2914C53.8695 38.684 51.7547 37.1645 51.3506 34.8944C50.9467 32.6255 52.4069 30.4682 54.6122 30.0756C56.8188 29.6828 58.9325 31.2039 59.3364 33.4727Z",
    fill: "#2D2A49"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.5723,
    cy: 29.8459,
    rx: 4.82754,
    ry: 3.81623,
    transform: "rotate(-10.0942 54.5723 29.8459)",
    fill: "url(#paint25_linear_12387_385808)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.9858 85.9481C51.0798 86.4761 49.1241 87.265 46.6175 87.7113C44.1109 88.1575 42.0043 88.0917 41.9103 87.5637C41.8165 87.037 43.771 86.2483 46.2776 85.8021C48.7842 85.3558 50.892 85.4214 50.9858 85.9481Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12387_385808",
    x1: -18.8622,
    y1: 63.8422,
    x2: 0.703608,
    y2: 60.7022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12387_385808",
    x1: 97.869,
    y1: 40.1706,
    x2: 78.4217,
    y2: 43.9759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12387_385808",
    x1: 37.9854,
    y1: 74.9083,
    x2: 65.2842,
    y2: 70.0485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FA7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0071BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12387_385808",
    x1: 73.4505,
    y1: -6.19444,
    x2: 50.5702,
    y2: -2.1212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12387_385808",
    x1: 60.4296,
    y1: 9.09574,
    x2: 73.898,
    y2: 6.69805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F86C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02A2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12387_385808",
    x1: -12.544,
    y1: 9.11385,
    x2: 10.3363,
    y2: 5.04062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12387_385808",
    x1: 4.95698,
    y1: 18.9711,
    x2: -8.5114,
    y2: 21.3687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F86C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02A2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12387_385808",
    x1: 25.564,
    y1: -12.9601,
    x2: 31.378,
    y2: -13.9952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12387_385808",
    x1: 29.2299,
    y1: -9.21227,
    x2: 38.7942,
    y2: -10.9149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_12387_385808",
    x1: 19.6659,
    y1: -7.50908,
    x2: 29.2295,
    y2: -9.21163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_12387_385808",
    x1: -18.1914,
    y1: 5.34373,
    x2: 78.0467,
    y2: -11.7889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F81B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_12387_385808",
    x1: 36.316,
    y1: -1.37705,
    x2: 36.316,
    y2: 41.0604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_12387_385808",
    x1: 72.5153,
    y1: 58.3116,
    x2: 76.6113,
    y2: 81.3203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE1722"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_12387_385808",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0536 85.8408) rotate(-10.0942) scale(10.2388 3.79179)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD721B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC1A21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_12387_385808",
    x1: 18.8788,
    y1: 79.3176,
    x2: 18.1475,
    y2: 75.2095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_12387_385808",
    x1: 27.9699,
    y1: 77.5706,
    x2: 27.5348,
    y2: 73.9113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_12387_385808",
    x1: 37.5606,
    y1: 76.0963,
    x2: 37.0573,
    y2: 73.2691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_12387_385808",
    x1: 46.9484,
    y1: 74.4187,
    x2: 46.4303,
    y2: 71.5086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_12387_385808",
    x1: 56.0432,
    y1: 72.8561,
    x2: 55.2142,
    y2: 69.1459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_12387_385808",
    x1: 65.4606,
    y1: 71.0255,
    x2: 64.7292,
    y2: 66.9174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D9DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_12387_385808",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.1122 40.6344) rotate(-10.0942) scale(16.1182 16.5822)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_12387_385808",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.1128 40.6342) rotate(-10.0942) scale(8.67084 8.92046)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#8DD5B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A156"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_12387_385808",
    x1: 18.3491,
    y1: 32.4796,
    x2: 18.3491,
    y2: 36.2173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_12387_385808",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.3441 34.1844) rotate(-10.0942) scale(16.1182 16.5822)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_12387_385808",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.345 34.1843) rotate(-10.0942) scale(8.67083 8.92046)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#8DD5B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A156"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_12387_385808",
    x1: 54.5811,
    y1: 26.0296,
    x2: 54.5811,
    y2: 29.7674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12387_385808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 106,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonsterIcon5);
export default __webpack_public_path__ + "static/media/MonsterIcon5.2392e4eb5e1ab08066ccc48587e0fc1d.svg";
export { ForwardRef as ReactComponent };